import React from 'react';
import styles from './index.module.less';
import CompHeaderSearch from './HeaderSearch';
import CompHeaderAccount from './HeaderAccount';
import CompHeaderCart from './HeaderCart';
import CompHeaderLangCountry from './HeaderLangCountry';

const CompHeaderAction: React.FC = React.memo(() => {
    return (
        <ul className={ styles['header-action'] }>
            <CompHeaderSearch />
            <CompHeaderAccount />
            <CompHeaderCart />
            <CompHeaderLangCountry />
        </ul>
    );
});

export default CompHeaderAction;
